import gql from 'graphql-tag'
import { priceLevels, cashFlow, kitchen, order, exportFragment } from './fragments'

export default gql`
	query getAppConfig {
		cashAssist {
			getAppConfig {
				...priceLevels
				...cashFlow
				...kitchen
				...order
				...exportFragment
				taraName
			}
		}
	}
	${priceLevels}
	${cashFlow}
	${kitchen}
	${order}
	${exportFragment}
`
